
export const COLORS={
    primaryColor:"#B2AFAF",
    overlayColor:"lightgrey",
    secondaryColor:"#1F4A45",
    whiteColor:"#fff",
    lightgreenColor:"#D1DDDB",
    blackColor:"#000"
    
}

export const fontFamilyAll="Nunito Sans";